// Supabase client — AUTH ONLY (architecture.md ADR-2, §10). The SPA uses supabase-js
// solely to get/refresh the JWT; all business logic goes through the Node API. Only the
// anon key reaches the browser.
import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(url, anon, {
  auth: { autoRefreshToken: true, persistSession: true, detectSessionInUrl: true },
});
